import React from 'react';
import AgencyNavbar from '../components/agencies/AgencyNavbar';
import Footer from '../components/layout/Footer';
import AgencyHero from '../components/agencies/AgencyHero';
import AgencyAgents from '../components/agencies/AgencyAgents';
import AgencyAuthority from '../components/agencies/AgencyAuthority';
import AgencyFinalCta from '../components/agencies/AgencyFinalCta';
import PartnerPaths from '../components/agencies/PartnerPaths';
import CustomerStory from '../components/marketing/CustomerStory';
import Workflow from '../components/marketing/Workflow';
import CommunitySection from '../components/marketing/CommunitySection';
export default function Agencies() { return <div className="min-h-screen bg-[#F7F8F7] font-lexend text-[#101F1F]"><AgencyNavbar /><main id="main-content"><AgencyHero /><CustomerStory /><Workflow /><AgencyAgents /><PartnerPaths /><AgencyAuthority /><CommunitySection /><AgencyFinalCta /></main><Footer /></div>; }